import { render, staticRenderFns } from "./SettingChangesWarning.vue?vue&type=template&id=f581fc00"
import script from "./SettingChangesWarning.vue?vue&type=script&lang=js"
export * from "./SettingChangesWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports